import moment from "moment";

export class SortProvider
{
    compareAsc = (a: any, b: any): number =>
    {
        if (a.toDate)
        {
            if (moment(a.toDate) < moment(b.toDate))
            {
                return -1;
            }
            if (moment(a.toDate) > moment(b.toDate))
            {
                return 1;
            }

            return 0;
        }
        else if (a.thruDate)
        {
            if (moment(a.thruDate) < moment(b.thruDate))
            {
                return -1;
            }
            if (moment(a.thruDate) > moment(b.thruDate))
            {
                return 1;
            }

            return 0;
        }
        else
        {
            if (moment(a.date) < moment(b.date))
            {
                return -1;
            }
            if (moment(a.date) > moment(b.date))
            {
                return 1;
            }

            return 0;
        }
    }

    compareDes = (a: any, b: any): number =>
    {
        if (a.toDate)
        {
            if (moment(b.toDate) < moment(a.toDate))
            {
                return -1;
            }
            if (moment(b.toDate) > moment(a.toDate))
            {
                return 1;
            }

            return 0;
        }
        else if (a.thruDate)
        {
            if (moment(b.thruDate) < moment(a.thruDate))
            {
                return -1;
            }
            if (moment(b.thruDate) > moment(a.thruDate))
            {
                return 1;
            }

            return 0;
        }
        else
        {
            if (moment(b.date) < moment(a.date))
            {
                return -1;
            }
            if (moment(b.date) > moment(a.date))
            {
                return 1;
            }

            return 0;
        }
    }

    sort = (data: any, sort: "Asc" | "Desc"): any =>
    {
        return data.sort(sort == "Asc" ? this.compareAsc : this.compareDes);
    }
}